import { render, staticRenderFns } from "./ViewEDSAndCriteria.vue?vue&type=template&id=d4b0602c&"
import script from "./ViewEDSAndCriteria.vue?vue&type=script&lang=js&"
export * from "./ViewEDSAndCriteria.vue?vue&type=script&lang=js&"
import style0 from "./ViewEDSAndCriteria.vue?vue&type=style&index=0&id=d4b0602c&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports